import { Box, Typography } from '@mui/material';

export const LoadingSpinner = () => {
  return (
    <Box
      role='status'
      aria-label='Loading'
      display='flex'
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
      gap={2}>
      <Box
        sx={{
          width: '44px',
          height: '44px',
          borderRadius: '50%',
          borderStyle: 'solid',
          borderWidth: '3px',
          borderColor: 'secondary.light',
          borderTopColor: 'primary.main',
          animation: 'spinner-rotate 0.8s infinite cubic-bezier(0.65, 0.05, 0.36, 1)',
          '@keyframes spinner-rotate': {
            to: { transform: 'rotate(1turn)' },
          },
        }}
      />
      <Typography
        variant='body2'
        sx={{
          color: 'text.secondary',
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          fontSize: '0.7rem',
          fontWeight: 600,
        }}>
        Loading
      </Typography>
    </Box>
  );
};
